var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShop1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M29.16 15.1866V23.1732C29.16 26.8532 26.1733 29.8399 22.4933 29.8399H10.84C7.16001 29.8399 4.17334 26.8532 4.17334 23.1732V15.2799C5.18667 16.3732 6.62667 16.9999 8.18667 16.9999C9.86667 16.9999 11.48 16.1599 12.4933 14.8132C13.4 16.1599 14.9467 16.9999 16.6667 16.9999C18.3733 16.9999 19.8933 16.1999 20.8133 14.8666C21.84 16.1866 23.4267 16.9999 25.08 16.9999C26.6933 16.9999 28.16 16.3466 29.16 15.1866Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6533 1.66675H12.6533L11.6666 11.4801C11.5866 12.3867 11.72 13.2401 12.0533 14.0134C12.8266 15.8267 14.64 17.0001 16.6666 17.0001C18.72 17.0001 20.4933 15.8534 21.2933 14.0267C21.5333 13.4534 21.68 12.7867 21.6933 12.1067V11.8534L20.6533 1.66675Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M30.4802 11.0267L30.0935 7.33341C29.5335 3.30675 27.7068 1.66675 23.8002 1.66675H18.6802L19.6668 11.6667C19.6802 11.8001 19.6935 11.9467 19.6935 12.2001C19.7735 12.8934 19.9868 13.5334 20.3068 14.1067C21.2668 15.8667 23.1335 17.0001 25.0802 17.0001C26.8535 17.0001 28.4535 16.2134 29.4535 14.8267C30.2535 13.7601 30.6135 12.4134 30.4802 11.0267Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M9.45344 1.66675C5.53344 1.66675 3.7201 3.30675 3.14677 7.37341L2.78677 11.0401C2.65344 12.4667 3.0401 13.8534 3.8801 14.9334C4.89344 16.2534 6.45344 17.0001 8.18677 17.0001C10.1334 17.0001 12.0001 15.8667 12.9468 14.1334C13.2934 13.5334 13.5201 12.8401 13.5868 12.1201L14.6268 1.68008H9.45344V1.66675Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8 22.2133C14.1067 22.3866 12.8267 23.8266 12.8267 25.5333V29.8399H20.4933V25.9999C20.5067 23.2133 18.8667 21.8933 15.8 22.2133Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop1);
export default __webpack_public_path__ + "static/media/shop-1.e7cbc2dfb02d9efdfab7b547c13950ed.svg";
export { ForwardRef as ReactComponent };